/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiV0BinaryConstructionDayReportContentIdGet$Json$Params {
  id: string;
}

export function apiV0BinaryConstructionDayReportContentIdGet$Json(http: HttpClient, rootUrl: string, params: ApiV0BinaryConstructionDayReportContentIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, apiV0BinaryConstructionDayReportContentIdGet$Json.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

apiV0BinaryConstructionDayReportContentIdGet$Json.PATH = '/api/v0/binary/construction-day-report/content/{id}';
